/**
 * @file: SchoolView.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 校方视图权限管理
 */
import request from '@/utils/request'

/**
 * 获取视图权限(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function schoolviewGet(data) {
  return request({
    type: 'biz',
    url: 'schoolview/get',
    method: 'post',
    data
  })
}

/**
 * 更新视图权限(wzp)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function schoolviewUpdate(data) {
  return request({
    type: 'biz',
    url: 'schoolview/update',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/SchoolView.js